export const pages = [
  {
    title: `Room Plan`,
    envMapFilename: `room-plan`,
    videoURL: `./videos/Scanovise Room Plan LinkedIn Youtube.mp4`,
    description: `Discover the power of Scanovise Room Plan Solution! 
Watch how easily you can scan your room and play around with placing furniture like sofas, coffee tables, and paintings.

👉 Download Scanovise on the Apple App Store today and start creating your dream space!
`,
    callToActionLink: `https://apps.apple.com/us/app/scanovise/id6472953989`,
  },
  {
    title: `3D Scan`,
    envMapFilename: `3d-scan`,
    videoURL: `./videos/Scanovise 3D Scan LinkedIn Youtube.mp4`,
    description: `Elevate Your Sharing Experience with Scanovise!

Why settle for flat photos and videos when you can captivate with full 3D? With Scanovise, transform any object into a detailed 3D model and let your friends or clients explore it in their own space with augmented reality! 

Feel the excitement of sharing not just an image, but an experience.

🤳 Simply point your iPhone, scan, and capture every angle.

🚀 Instantly share your creation and watch as your friends interact with it as if it were right in front of them.

Step out of the frame and into the future—make every share a showstopper with Scanovise.

Download now and start your journey to more dynamic sharing!
`,
    callToActionLink: `https://apps.apple.com/us/app/scanovise/id6472953989`,
  },
  {
    title: `AR Portal`,
    envMapFilename: `ar-portal`,
    videoURL: `./videos/Inovise AR Portal LinkedIn Youtube.mp4`,
    description: `Elevate Your Business with Inovise AR Portal!
Discover the power of Augmented Reality with Inovise AR Portal, designed to transform customer experiences and drive business success.

Why Choose Inovise AR Portal?
Boost Customer Engagement: Create immersive and interactive experiences that keep customers engaged longer.
Improve Training Efficiency: Develop realistic training simulations that enhance employee performance and knowledge retention.
Gain Valuable Insights: Collect data on user interactions to better understand customer preferences and optimize your offerings.
Stay Competitive: Differentiate your brand with cutting-edge AR technology that captivates and retains customers.

Try It Now!
📱Scan the QR Code or click the link in the comment.
🤳Point your phone camera to the front. 
📍Tap to place the AR Portal.
🚶🏻Walk into the room and discover the magic of the AR Portal.

For more information or to book an appointment, Click the below calendar to connect with us. Let’s discuss your requirements and make it happen!
`,
    callToActionLink: `https://calendly.com/elie-hajjar/30min`,
  },
  {
    title: `AR Stencil Cube`,
    envMapFilename: `ar-stencil-cube`,
    videoURL: `./videos/Inovise Coffee Ar LInkedIn Youtube.mp4`,
    description: `Revolutionize Your Coffee Shop with Inovise AR Stencil Cube! ☕
Say goodbye to dull PDF menus and hello to an immersive, eye-catching experience! 
🌟 Introducing the Inovise AR Stencil Cube, a cutting-edge 3D display for your coffee menu. Watch your coffee products come to life, captivating your customers!

How to Experience:
📱Scan the QR Code in the comment
📋 Follow the Steps
🤳🏽 Point Your Phone Camera at the QR Code to see the AR Stencil Cube 3D Objects.
`,
    callToActionLink: `https://inovise.outseta.com/auth?widgetMode=register&planUid=79OvOPQE&planPaymentTerm=month&skipPlanOptions=true#o-anonymous`,
  },
  {
    title: `AR Business Cards`,
    envMapFilename: `ar-business-cards`,
    videoURL: `./videos/Inovise AR Business Card LinkedIn Youtube.mp4`,
    description: `Transform Your Networking with Inovise's AR Business Cards!
Want to make a lasting impression at your next meeting or event? 
Meet Inovise's AR Business Cards – the future of professional connections!

✨ Why Choose Inovise AR Business Cards? ✨
📈 Stand Out: Instantly grab attention with interactive, 3D content.
🤝 Memorable: Ensure your contacts remember you long after the meeting.
📱 Convenient: Share your portfolio, videos, and contact info with a quick scan.
🌐 Modern: Ideal for conferences, and everyday professional use.

🚀 Ready to change how you network? 🚀
👉 Try it now: Click the link below and experience the future of business cards. 
🤳🏽 Simply point your camera at the related business card to see the magic unfold!
✍️ Sign up and start networking today!
`,
    callToActionLink: `https://inovise.outseta.com/auth?widgetMode=register&planUid=OW4ry3Qg&planPaymentTerm=annual&skipPlanOptions=true#o-anonymous`,
  },
  {
    title: `AR Menu`,
    envMapFilename: `ar-menu`,
    videoURL: `./videos/Inovise AR Menu LinkedIn Youtube.mp4`,
    description: `🍽️ Revolutionize Your Restaurant with Inovise AR Menu! 🍽️

🌟 Imagine walking into a restaurant and having the menu come alive in your hands. This isn't the future; it's now, with Inovise AR Menu!

🎥 Transform Your Dining Experience:
🍔 Animated 3D Visuals: Watch dishes come alive with stunning, mouth-watering 3D animations.

👨‍🍳 Virtual Chef Experiences: Let customers be entertained by a virtual chef preparing their meals right at the table.

📊 Nutritional Info: Provide detailed nutritional information at a glance.

📱 Effortless Ordering: Streamline your service with direct AR menu ordering.

🔍 Enhanced Discovery: Guide your customers through a captivating culinary journey.

🌟 Why Choose Inovise AR Menu?
✔Stand out from the competition with cutting-edge AR technology.

✔️Create unforgettable dining experiences that customers will rave about.

✔️Boost customer engagement and satisfaction.

Experience the Future of Dining NOW: https://ar.inovise.ai/p/InoviseARMenu
🤳🏽Point your phone camera at the menu.
🪄Witness the magic of Inovise AR Menu!

🚀 Don’t just serve food; serve an experience.
📅 Contact us and join the revolution!
`,
    callToActionLink: `https://calendly.com/elie-hajjar/30min`,
  },
  {
    title: `3D Customizer`,
    envMapFilename: `3d-customizer`,
    videoURL: `./videos/Inovise Customizer LinkedIn Youtube.mp4`,
    description: `Introducing the Inovise 3D Customizer! The Game-Changer 👨🏻‍💻
Redefining e-commerce, one 3D experience at a time.

Tired of old-school e-commerce holding you back? In 2024, outdated methods aren't just a hassle—they're costing you sales and frustrating your customers.

🎨 Why Your Customers Will Love It:
Instantly change product colors
Add personal logos
Apply cool textures
Create unique designs with AI
Choose from thousands of available images
Download the 3D model and view it in AR

📈 Why Your Business Needs It:
Boost brand loyalty
Increase engagement
Slash returns
Skyrocket sales

It’s time to leave the past behind. Elevate your e-commerce game and give your customers an unforgettable shopping experience with Inovise 3D Customizer.
📆 Contact us to implement it on your e-commerce and transform your business today!
`,
    callToActionLink: `https://calendly.com/elie-hajjar/30min`,
  },
]

export const socialsButtons = [
  {
    description: `LinkedIn`,
    link: `https://www.linkedin.com/company/inovise/`,
  },
  {
    description: `Instagram`,
    link: `https://www.instagram.com/i_inovise/`,
  },
  {
    description: `Facebook`,
    link: `https://www.facebook.com/profile.php?id=61555418797501`,
  },
  {
    description: `Youtube`,
    link: `https://www.youtube.com/@InoviseInc.`,
  },
  {
    description: `Tiktok`,
    link: `https://www.tiktok.com/@inovise6`,
  },
]
